const fin = {
  TITLE: "Finnhouse",
  DESCRIPTION: "Suomalainen kilpapeliyhteisö league of legendsin parissa.",
  HEADER: {
    HOME: "Koti",
    SCHEDULE: "Aikataulu",
    RESULTS: "Tulokset",
    SCOREBOARD: "Tulokset",
    TEAMS: "Joukkueet",
    GALLERY: "Galleria",
    ABOUT: "Meistä",
    PLAYERS: "Pelaajat",
    LEADERBOARD: "Ranked",
    STATS: "Kausitilastot",
    CHAMPIONS: "Hahmotilastot",
  },
  SCOREBOARD: {
    GRID_PLACEMENT: "S",
    GRID_TEAM_NAME: "Joukkue",
    GRID_SERIES_WINS: "Sarjavoitot",
    GRID_SERIES_LOSSES: "Sarjahäviöt",
    GRID_GAME_WINS: "Pelivoitot",
    GRID_GAME_LOSSES: "Pelihäviöt",
    GRID_SERIES_WINS_SHORT: "S V",
    GRID_SERIES_LOSSES_SHORT: "S H",
    GRID_GAME_WINS_SHORT: "P V",
    GRID_GAME_LOSSES_SHORT: "P H",
    GRID_TEAM_WINS: "V",
    GRID_TEAM_LOSSES: "H",
    FPL_REGULAR_PLACEMENTS_TITLE: "FPL runkosarja",
    FPL_PLAYOFFS_PLACEMENTS_TITLE: "FPL pudotuspelit",
    FPL_RELEGATIONS_PLACEMENTS_TITLE: "FPL ylös alas",
    NO_TEAMS_AVAILABLE: "Tulosten näyttäminen epäonnistui.",
  },
  PLAYOFFCHART: {
    FINAL_UPPERBRACKET_WINNER: "Ylälohkon Voittaja",
    FINAL_LOWERBRACKET_WINNER: "Alalohkon Voittaja",
    LOSER_UPPERBRACKET: "Ylälohkon Häviäjä: K",
    WINNER_LOWERBRACKET: "Alalohkon Voittaja: K",
    FINAL: "Finaali",
    FINALIST: "MESTARUUS",
    ROUND: "KIERROS",
    UPPER_BRACKET: "YLÄLOHKO",
    LOWER_BRACKET: "ALALOHKO",
  },
  TEAMS: {
    TITLE: "Finnish pro league",
    NO_TEAMS_TO_SHOW: "Ei joukkueita näytettävänä",
    NO_DESCRIPTION: "Kuvausta ei ole saatavilla",
    PRIMARY_ROSTER: "Pääkokoonpano",
    SUBSTITUTES: "Varapelaajat",
    DIRECTORY_SUBTITLE:
      "Valitse joukkue nähdäksesi kokoonpanon, otteluhistorian ja kausisijoitukset.",
    VIEW_TEAM: "Avaa joukkueen {team} sivu",
    VIEW_TEAM_SHORT: "Avaa joukkue →",
    BACK_TO_TEAMS: "← Takaisin joukkueisiin",
    LOADING: "Ladataan joukkuetta…",
    LOAD_ERROR: "Joukkueen tietoja ei voitu ladata.",
    NOT_FOUND: "Joukkuetta ei löytynyt.",
    TAB_ROSTER: "Kokoonpano",
    TAB_HISTORY: "Otteluhistoria",
    TAB_PLACEMENTS: "Kausisijoitukset",
    TABS_LABEL: "Joukkueen osiot",
    SOCIALS_LABEL: "Joukkueen linkit",
    HIGHLIGHT_SEASONS: "Kaudet",
    HIGHLIGHT_TITLES: "Mestaruudet",
    HIGHLIGHT_MATCHES: "Ottelut",
    NO_ROSTER: "Kokoonpanoa ei ole saatavilla.",
    NO_MATCH_HISTORY: "Tälle joukkueelle ei löytynyt pelattuja otteluita.",
    NO_CHAMPIONS: "Ei champ-dataa",
    CHAMPIONS_LABEL: "Pelatut championit",
    GAME_CHAMPS_LABEL: "Pelin {number} championit",
    TEAM_CHAMPIONS_LABEL: "Oman joukkueen championit",
    OPPONENT_CHAMPIONS_LABEL: "Vastustajan championit",
    RESULT_WIN: "V",
    RESULT_LOSS: "H",
    RESULT_DRAW: "T",
    HISTORY_ROW_LABEL: "Avaa ottelu vs {opponent}, tulos {score}",
    NO_PLACEMENTS: "Tälle joukkueelle ei löytynyt kausisijoituksia.",
    FILTER_SEASON: "Kausi",
    ALL_SEASONS: "Kaikki kaudet",
    COLUMN_SEASON: "Kausi",
    COLUMN_PLACE: "Sijoitus",
    COLUMN_RECORD: "Sarja",
    COLUMN_GAMES: "Pelit",
    COLUMN_RESULT: "Tulos",
    PLACE: "#{place}",
    PLACE_NA: "—",
    CHAMPION: "Mestari",
    REGULAR_SEASON: "Runkosarja",
  },
  PLAYERS: {
    HEADER: "Pelaaja ränkit EUW serverillä",
  },
  PLAYER_PAGE: {
    CHAMPIONS: "Championit",
    UNIQUE_CHAMPS: "{count} championia",
    SHOW_MORE_CHAMPS: "Näytä lisää ({count})",
    SHOW_LESS_CHAMPS: "Näytä vähemmän",
    MULTIKILL: "MK",
    ROLE: "Rooli",
    VIEW_MATCH: "Katso ottelun tiedot",
  },
  LIVE: {
    TITLE: "SUORA LÄHETYS!",
    LIVE_NOW_TITLE: "LÄHETYS KÄYNNISSÄ",
    VIEWERS: "{count} katsojaa",
    LOADING: "Tarkistetaan Twitch-tilaa…",
    CHAT_TITLE: "Twitch-chat",
    LIVE_BADGE: "Live",
    FOLLOW_TWITCH: "Seuraa meitä Twitchissä",
    EXPAND: "Laajenna",
    COLLAPSE: "Pienennä",
    SHOW_CHAT: "Näytä chat",
    HIDE_CHAT: "Piilota chat",
    OPEN_BOTH_STREAMS: "Avaa molemmat lähetykset",
    POP_OUT: "Irrotta",
    DOCK: "Kiinnitä",
    POPOUT_ACTIVE: "Lähetys toistuu irrotetussa soittimessa.",
  },
  GALLERY: {
    VIEW_MORE: "KATSO KUVAT",
  },
  TRACKER: {
    DAYS: "päivää",
    HOURS: "tuntia",
    MINUTES: "minuuttia",
    SECONDS: "sekuntia",
    LIVE: "Peli on käynnissä",
    LIVE_MATCHES: "LIVE-OTTELUT",
    NEXT_MATCH: "SEURAAVA OTTELU",
    NO_CONTENT: "UUSI FPL-KAUSI ALKAA ENSI VUONNA",
  },
  COMMON: {
    VS: "VS",
    TBD: "TBD",
    TEAM_LOGO_ALT: "{team} - joukkueen logo",
    SKIP_TO_CONTENT: "Siirry pääsisältöön",
  },
  HERO: {
    MAP_ALT: "Suomen kartta",
  },
  DESCRIPTION_SECTION: {
    BODY: "Finnhouse on suomalainen League of Legends -yhteisö ja turnaustoimija, joka rakentaa pelajaalähtöistä esports-kulttuuria sydämellä ja yhdessä yhteisön kanssa.",
    MAP_DESC: "SUOMALAINEN LOL-KESKUS",
    RIFT_DESC: "KILPAPELAAMISEN KOTI",
    PORO_DESC: "YHDESSÄ RAKENNETTU",
    MAP_ALT: "Suomen kartta -kuvake",
    RIFT_ALT: "Summoner's Rift -kuvake",
    PORO_ALT: "League of Legends -poro",
  },
  BUTTONS: {
    READ_MORE: "LUE LISÄÄ",
  },
  WEEKDAYS: {
    MON: "Maanantai",
    TUE: "Tiistai",
    WED: "Keskiviikko",
    THU: "Torstai",
    FRI: "Perjantai",
    SAT: "Lauantai",
    SUN: "Sunnuntai",
  },
  MONTHS: {
    JAN: "Tammikuu",
    FEB: "Helmikuu",
    MAR: "Maaliskuu",
    APR: "Huhtikuu",
    MAY: "Toukokuu",
    JUN: "Kesäkuu",
    JUL: "Heinäkuu",
    AUG: "Elokuu",
    SEP: "Syyskuu",
    OCT: "Lokakuu",
    NOV: "Marraskuu",
    DEC: "Joulukuu",
  },
  NEWS: {
    NEWS_TITLE: "Uutiset",
    SCHEDULE: "Aikataulu",
    NO_UPCOMING_MATCHES: "Ei tulevia otteluita",
    SCHEDULE_EMPTY_HINT: "Seuraavan kauden ottelut julkaistaan tänne.",
    MATCH: "Viikko",
  },
  UPCOMING: {
    FILTER: "Rajaa joukkueella",
  },
  FOOTER: {
    CONTACT: "OTA YHTEYTTÄ",
    CONTACT_DESCRIPTION: "Kysyttävää? Voit olla yhteydessä - ",
    DISCORD: "DISCORDISSA KÄYTTÄJÄÄN: ",
    EMAIL: "SÄHKÖPOSTITSE",
    LINKS: "SOME LINKIT",
    INFO: "TIEDOT & KÄYTÄNNÖT",
    TERMS: "Käyttöehdot",
    PRIVACY: "Tietosuojakäytäntö",
    COOKIES: "Evästeasetukset",
    SPONSORS: "YHTEISTYÖKUMPPANIT",
    COPY: "Klikkaa kopioidaksesi",
    COPIED: "KOPIOITU",
    COPYRIGHT: "Kaikki oikeudet pidätetään.",
  },
  COOKIES: {
    TITLE: "Evästeet",
    SETTINGS_TITLE: "Evästeasetukset",
    DESCRIPTION:
      "Käytämme vapaaehtoisia evästeitä sivuston kehittämiseen ja sen toiminnan parantamiseen. Hyväksymällä asetamme istuntoevästeen tätä varten (ei nimeä tai sähköpostia). Perus käyntilaskenta ja arvioidut uniikit kävijät toimivat silti ilman evästeitä omalla palvelinanalytiikalla. Voit hyväksyä tai hylätä vapaaehtoiset evästeet.",
    ACCEPT: "Hyväksy",
    REJECT: "Hylkää",
    CLOSE: "Sulje",
  },
  LEGAL: {
    TERMS: {
      TITLE: "Käyttöehdot",
      UPDATED: "Päivitetty: 29.7.2026",
      INTRO:
        "Nämä käyttöehdot koskevat Finnhouse-sivustoa (finnhouse.fi), jota ylläpitää Finnhouse-yhteisö. Käyttämällä sivustoa hyväksyt nämä ehdot.",
      SECTIONS: [
        {
          TITLE: "Mikä on Finnhouse",
          BODY: "Finnhouse järjestää suomalaisia League of Legends -kilpailuja ja yhteisötoimintaa, kuten FPL-, FCL- ja FHL-sarjoja. Sivusto julkaisee otteluohjelmia, tuloksia, tilastoja, joukkuetietoja, lähetyksiä ja muuta aiheeseen liittyvää sisältöä.",
        },
        {
          TITLE: "Sivuston käyttö",
          BODY: "Voit käyttää sivustoa henkilökohtaiseen, ei-kaupalliseen käyttöön. Älä häiritse palvelua, kuormita järjestelmiä automaattisella keruulla, kierrä suojauksia tai käytä sivustoa lainvastaisesti. Ylläpitotyökalut ovat vain valtuutetulle henkilökunnalle.",
        },
        {
          TITLE: "Sisältö ja paikkansapitävyys",
          BODY: "Ottelutulokset, sijoitukset, pelaajatilastot ja ohjelmat on tarkoitettu tiedoksi ja yhteisön käyttöön. Pyrimme pitämään tiedot ajantasaisina, mutta niitä voidaan päivittää, korjata tai julkaista viiveellä. Sisältö tarjotaan sellaisenaan ilman täydellisyys- tai ajantasaisuustakuuta.",
        },
        {
          TITLE: "Immateriaalioikeudet",
          BODY: "Finnhousen brändi, sivuston ulkoasu ja alkuperäinen sisältö kuuluvat Finnhouseen tai kumppaneille, ellei toisin mainita. League of Legends ja siihen liittyvät aineistot ovat omistajiensa tavaramerkkejä. Älä kopioi, jaa tai käytä kaupallisesti sivuston sisältöä ilman lupaa.",
        },
        {
          TITLE: "Kolmannen osapuolen linkit ja palvelut",
          BODY: "Sivusto voi linkittää ulkoisiin palveluihin, kuten Twitchiin, YouTubeen, Discordiin ja kumppanisivustoihin. Emme vastaa kolmansien osapuolten sisällöstä tai palveluista.",
        },
        {
          TITLE: "Vastuunrajoitus",
          BODY: "Finnhouse ei vastaa välillisistä tai seuraamuksellisista vahingoista, jotka liittyvät sivuston käyttöön. Sovellettavan lain sallimissa rajoissa vastuumme rajoittuu tahalliseen tai törkeän huolimattomaan toimintaan.",
        },
        {
          TITLE: "Muutokset ja yhteystiedot",
          BODY: "Voimme päivittää ehtoja palvelun muuttuessa. Jatkamalla käyttöä päivitysten jälkeen hyväksyt uudet ehdot. Kysymykset: finnhouse@gmail.com tai Discord-käyttäjä FLOORA.",
        },
      ],
    },
    PRIVACY: {
      TITLE: "Tietosuojakäytäntö",
      UPDATED: "Päivitetty: 29.7.2026",
      INTRO:
        "Tämä käytäntö kuvaa, miten Finnhouse käsittelee tietoja, kun käytät finnhouse.fi-sivustoa. Pyrimme keräämään vain sen, mikä on tarpeen sivuston ylläpitoon ja kehittämiseen.",
      SECTIONS: [
        {
          TITLE: "Rekisterinpitäjä",
          BODY: "Finnhouse-yhteisö\nYhteystiedot: finnhouse@gmail.com\nDiscord: FLOORA",
        },
        {
          TITLE: "Käsittelemämme tiedot",
          BODY: "Käytöstäsi riippuen voimme käsitellä:\n• Teknisiä pyyntötietoja sivujen toimittamiseksi (esim. selaintyyppi, likimääräinen ajoitus)\n• Ylläpitäjien kirjautumistietoja valtuutetulle henkilökunnalle\n• Koottuja käyntitilastoja ja arvioituja uniikkeja kävijöitä lyhytaikaisella palvelinpäivän tiivistelmällä (ei evästeitä; emme tallenna raakaa IP-osoitetta)\n• Suostumuksella: istuntoevästettä, joka auttaa sivuston kehittämistä",
        },
        {
          TITLE: "Evästeet ja vastaavat tekniikat",
          BODY: "Vapaaehtoisia evästeitä käytetään sivuston kehittämiseen vain, jos hyväksyt ne evästebannerissa. Voit avata evästeasetukset uudelleen sivuston alatunnisteesta. Vapaaehtoisten evästeiden hylkääminen poistaa tähän liittyvän seurannan. Perus käyntilaskenta ja arvioidut uniikit kävijät toimivat silti ilman evästeitä.",
        },
        {
          TITLE: "Oma analytiikkamme",
          BODY: "Käytämme omaan infrastruktuuriimme perustuvaa first-party-analytiikkaa. Jokainen käynti kasvattaa päivittäisiä laskureita. Uniikkien kävijöiden arvioimiseksi ilman evästeitä palvelin muodostaa päiväkohtaisen pseudonyymin avaimen teknisistä pyyntötiedoista (kuten IP-osoite ja selaintyyppi), tiivistää sen heti ja tallentaa vain tiivistelmän — ei raakaa IP-osoitetta. Jos hyväksyt evästeet, voimme käyttää myös istuntoevästettä sivuston kehittämiseen. Emme kerää analytiikkaan nimeä, sähköpostia tai julkista käyttäjätiliä.",
        },
        {
          TITLE: "Sivuston kehittäminen",
          BODY: "Käytämme koottua analytiikkaa ja suostumuksellasi vapaaehtoisia evästeitä Finnhousen kehittämiseen — esimerkiksi ongelmien korjaamiseen, ominaisuuksien hiomiseen ja sivuston tekemiseen selkeämmäksi ja hyödyllisemmäksi. Emme myy henkilötietoja emmekä rakenna näistä tiedoista yksilöllisiä markkinointiprofiileja.",
        },
        {
          TITLE: "Käsittelyn oikeusperusteet (EU/ETA)",
          BODY: "Perustamme käsittelyn oikeutettuun etuun sivuston perustoiminnassa, koottuihin tilastoihin ja lyhytaikaisten palvelintiivistelmien avulla arvioituihin uniikkeihin kävijöihin. Vapaaehtoiset evästeet sivuston kehittämiseen perustuvat suostumukseesi. Ylläpitäjien todennus perustuu sivuston hallinnoinnin tarpeeseen.",
        },
        {
          TITLE: "Säilytys",
          BODY: "Analytiikan yhteenvetotiedot säilytetään kootussa muodossa palvelun kehittämistä varten. Kävijätiivistelmät vaihtuvat päivittäin emmekä rakenna niistä pitkäaikaisia profiileja. Istuntoevästeet päättyvät, kun suljet selaimen. Ylläpito- ja operatiiviset tiedot säilytetään vain tarpeen mukaan.",
        },
        {
          TITLE: "Oikeutesi",
          BODY: "Jos GDPR koskee sinua, sinulla voi olla oikeus tarkastaa, oikaista, poistaa tai rajoittaa tietojen käsittelyä, vastustaa käsittelyä sekä peruuttaa suostumus vapaaehtoisiin evästeisiin. Ota yhteyttä: finnhouse@gmail.com. Voit myös tehdä valituksen paikalliselle tietosuojaviranomaiselle.",
        },
        {
          TITLE: "Muutokset",
          BODY: "Voimme päivittää tätä käytäntöä, kun sivusto, evästeet tai analytiikka muuttuvat. Ajantasainen versio on aina saatavilla tällä sivulla.",
        },
      ],
    },
  },
  ABOUT: {
    INTRODUCTION: {
      TITLE: "MIKÄ ON FINNHOUSE?",
      PARAGRAPH: {
        ONE: "Finnhouse syntyi vuonna 2021 halusta rakentaa parempaa kotia suomalaiselle League of Legends -skeneelle. Vuosien aikana olemme kasvaneet pienestä yhteisöprojektista Suomen suurimmaksi LoL-pohjaiseksi turnaustoimijaksi.",
        TWO: "Järjestämämme sarjat – FPL, FCL ja FHL – tarjoavat pelikokemuksia niin huipulle tähtääville kuin rentoa meininkiä etsiville. Olemme järjestäneet kymmeniä turnauksia, tuottaneet satoja lähetyksiä ja rakentaneet toimintaa yhdessä vapaaehtoisten, pelaajien ja fanien kanssa.",
        THREE:
          "Finnhouse ei ole pelkkä liiga – se on yhteisö, joka haluaa kehittää suomalaista esportsia pelaajalähtöisesti ja sydämellä.",
      },
    },
    POINTS: {
      EYEBROW: "Mitä teemme",
      SECTION_TITLE: "Enemmän kuin turnauksia",
      SECTION_SUBTITLE:
        "Finnhouse rakentaa tilaa kilpailulle, yhteisölle ja kasvulle suomalaisessa LoL-skenessä.",
      ONE: {
        TITLE: "Suomalainen LoL-keskus",
        PARAGRAPH:
          "Finnhouse kokoaa yhteen Suomen League of Legends -yhteisön – pelaajat, joukkueet ja fanit.",
      },
      TWO: {
        TITLE: "Kilpapelaamisen koti",
        PARAGRAPH:
          "Me järjestämme liigoja, turnauksia ja tapahtumia – aina harrastepeleistä LAN-finaaleihin asti.",
      },
      THREE: {
        TITLE: "Yhdessä rakennettu",
        PARAGRAPH:
          "Toiminta kasvaa vapaaehtoisvoimin. Jokainen voi osallistua ja vaikuttaa – yhteisö on ytimessä.",
      },
    },
    CASTERS: {
      EYEBROW: "Tiimi",
      TITLE: "Ketä me Finnhousella ollaan",
      SUBTITLE: "Äänet ja kasvot lähetysten, tapahtumien ja yhteisön takana.",
      ROLE: {
        CASTER: "Selostaja",
        HOST: "Juontaja",
      },
      NO_CASTERS: "Selostajien näyttäminen epäonnistui.",
    },
  },
  LATEST_GAMES: {
    TITLE: "Seuraavat pelit",
  },
  RECENT_GAMES: {
    TITLE: "Viimeisimmät pelit",
    NO_RECENT_GAMES_AVAILABLE: "Viimeisimpiä pelejä ei ole saatavilla.",
    VIEW_ALL: "Katso kaikki tulokset",
  },
  SCHEDULE: {
    VIEW_FULL: "Katso koko aikataulu",
    PAGE_TITLE: "Aikataulu",
    PAGE_SUBTITLE: "Kaikki tulevat ottelut",
    LOADING: "Ladataan aikataulua…",
    WATCH_STREAM: "Katso Twitchissä",
    STREAM_TBD: "Striimin kanava TBD",
    WATCH_VOD: "Katso YouTubessa",
    VIEW_MATCH_DETAILS: "Katso ottelun tiedot",
    FILTER_TEAMS: "Suodata joukkueittain",
    CLEAR_FILTER: "Tyhjennä suodatin",
    NO_FILTER_RESULTS: "Ei otteluita valituille joukkueille",
    NO_FILTER_RESULTS_HINT: "Kokeile valita muita joukkueita tai tyhjennä suodatin.",
  },
  MATCH_DETAIL: {
    LOADING: "Ladataan ottelua…",
    LOAD_ERROR: "Ottelun tietojen lataus epäonnistui.",
    NOT_FOUND: "Ottelua ei löytynyt.",
    INVALID_MATCH: "Virheellinen ottelulinkki.",
    BACK_TO_RESULTS: "← Takaisin tuloksiin",
    GAME_TABS: "Sarjan pelit",
    GAME_TAB: "Peli {number}",
    GAME_TITLE: "Peli {number}",
    WINNER_LABEL: "{team} voitti",
    WINNER_SHORT: "{team} V",
    NO_GAMES: "Tälle ottelulle ei ole vielä pelidataa",
    NO_GAMES_HINT:
      "Yksittäiset pelitilastot näkyvät täällä, kun Riot-pelitunnukset on haettu tälle sarjalle.",
    VICTORY: "Voitto",
    DEFEAT: "Tappio",
    KILLS: "Tapot",
    OBJECTIVES: "Joukkueen objektiivit",
    TURRETS: "Tornit",
    DRAGONS: "Dragonit",
    BARONS: "Baronit",
    GRUBS: "Grubit",
    HERALD: "Herald",
    ELDERS: "Elderit",
    YES: "Kyllä",
    NO: "Ei",
    BANS: "Bannit",
    NO_BAN: "Ei bänniä",
    PLAYER_STATS: "Pelaajien suoritus",
    CHAMPION: "Champ",
    PLAYER: "Pelaaja",
    DAMAGE: "Damage",
    GOLD: "Kulta",
    VISION: "Vision",
    ITEMS: "Itemit",
    CS_PER_MIN: "/min",
    CS15_DIFF: "CS@15 Δ",
    DPM: "DPM",
    DRAGON_TYPES: "Otetut dragonit",
    BANNED_CHAMPION: "Bannattu champion {id}",
    GRAPHS: "Kaaviot",
    GRAPHS_TITLE: "Ottelun kaaviot",
    GRAPHS_DAMAGE: "Champion-vahinko",
    GRAPHS_GOLD: "Ansaittu kulta",
    GRAPHS_CS: "CS",
    GRAPHS_VISION: "Vision-pisteet",
    GRAPHS_DPM: "Damage per minute",
    GRAPHS_KP: "KP%",
    GRAPHS_CHAMPION_ALT: "{champion} champion-kuvake",
    CS: "CS",
  },
  RESULTS: {
    PAGE_TITLE: "Tulokset",
    PAGE_SUBTITLE: "Kauden sijoitukset ja pelatut ottelut",
    FILTER_SEASON: "Kausi",
    MATCHES_TITLE: "Pelatut ottelut",
    CURRENT_SEASON_LIVE: "live",
    LOADING: "Ladataan tuloksia…",
    NO_RESULTS: "Ei pelattuja otteluita vielä",
    NO_RESULTS_HINT: "Tulokset näkyvät täällä, kun ottelut on pelattu.",
    NO_SEASON_RESULTS: "Ei pelattuja otteluita tällä kaudella",
    NO_SEASON_RESULTS_HINT:
      "Kokeile toista kautta tai palaa myöhemmin, kun pelejä on pelattu lisää.",
    NO_FILTER_RESULTS: "Ei otteluita valituille joukkueille",
    NO_FILTER_RESULTS_HINT: "Kokeile valita muita joukkueita tai tyhjennä suodatin.",
  },
  LEADERBOARD: {
    PAGE_TITLE: "FPL Ranked",
    TAB_LEADERBOARD: "Ranked",
    TAB_RISERS: "Nousijat ja putoajat",
    RISERS_DESCRIPTION:
      "Suurimmat pelaajien LP-muutokset keskiyöstä valitulle päivälle tai kokonaiselle viikolle (ma–su, Helsinki). Tämän päivän tulokset päivittyvät live 15 minuutin välein.",
    LIVE_RANKINGS: "Live-sijoitukset",
    RANKS_REFRESHED: "Sijoitukset päivitetty {time}",
    SAME_AS_TEAM_PAGES: "Sama data kuin joukkuesivuilla",
    LAST_UPDATED: "Viimeksi päivitetty",
    NO_RANK_DATA: "Ei sijoitustietoja vielä",
    STANDINGS: "Sijoitukset",
    HISTORY: "Historia",
    ERROR_LOAD: "Ranked-tietoja ei voitu ladata",
    LOADING: "Ladataan…",
    NO_TEAMS: "FPL-joukkueita pelaajadatalla ei löytynyt.",
    TAB_TEAMS: "Joukkueet",
    TAB_INDIVIDUAL: "Yksilöt",
    FILTER_TEAM: "Joukkue",
    FILTER_ROLE: "Rooli",
    ALL_PLAYERS: "Kaikki pelaajat",
    ALL_ROLES: "Kaikki roolit",
    SOLO_DUO: "Solo / Duo",
    COLUMN_TEAM: "Joukkue",
    COLUMN_PLAYER: "Pelaaja",
    COLUMN_RANK: "Rank",
    COLUMN_WINRATE: "Voittoprosentti",
    ACTIVE_ROSTER: "Aktivinen rosteri",
    SUBSTITUTES: "Varapelaajat",
    VIEW_OPGG: "Katso OP.GG:ssä →",
    SUB_BADGE: "Vara",
    UNRANKED: "Ei rankkia",
    LP: "LP",
    RANK_EMBLEM_ALT: "{tier} -rankin tunnus",
    PROFILE_ICON_ALT: "Pelaajan profiilikuva",
    PERIOD_DAY: "Päivä",
    PERIOD_WEEK: "Viikko",
    PERIOD_GROUP: "Jakso",
    PICKER_DAY: "Päivä",
    PICKER_WEEK: "Viikko",
    NO_DAYS_YET: "Ei päiviä vielä",
    NO_WEEKS_YET: "Ei viikkoja vielä",
    DAILY_TODAY: "Tänään",
    WEEKLY_THIS_WEEK: "Tämä viikko",
    DAILY_LIVE_BADGE: "Live",
    DAILY_UPDATED_THROUGH: "Kokonais-LP-muutos keskiyöstä · päivitetty {time}",
    WEEKLY_UPDATED_THROUGH: "Kokonais-LP-muutos maanantaista · päivitetty {time}",
    VIEW_PLAYER_OPGG: "Avaa {player} OP.GG:ssä",
    VIEW_PLAYER_PROFILE: "Näytä pelaajan {player} FPL-tilastot",
    VIEW_PLAYER_RANK_SITE: "Näytä {player} palvelussa {site} (solo queue)",
    ERROR_LOAD_MOVERS: "Muutoksia ei voitu ladata",
    EMPTY_DAILY_WAIT:
      "Päivän LP-muutokset näkyvät keskiyön tilannekuvan ja päivän ensimmäisen päivityksen jälkeen.",
    EMPTY_DAILY_NO_CHANGES: "Ei LP-muutoksia valitulla päivällä.",
    EMPTY_DAILY_NO_SNAPSHOTS: "Vertailukelpoisia tilannekuvia ei löytynyt valitulle päivälle.",
    EMPTY_WEEKLY_WAIT:
      "Viikoittaiset LP-muutokset näkyvät maanantain tilannekuvan ja viikon ensimmäisen päivityksen jälkeen.",
    EMPTY_WEEKLY_NO_CHANGES: "Ei LP-muutoksia valitulla viikolla.",
    EMPTY_WEEKLY_NO_SNAPSHOTS: "Vertailukelpoisia tilannekuvia ei löytynyt valitulle viikolle.",
    TOP_DAILY_GAINERS: "Päivän suurimmat nousijat",
    TOP_WEEKLY_GAINERS: "Viikon suurimmat nousijat",
    TOP_DAILY_LOSERS: "Päivän suurimmat putoajat",
    TOP_WEEKLY_LOSERS: "Viikon suurimmat putoajat",
    NO_HISTORY: "Ei historiaa vielä. Tilannekuvat tallennetaan jokaisen päivän alussa ja lopussa.",
    TIMELINE: "Aikajana",
    TIMELINE_ARIA: "Kaavion aikajana",
    GRANULARITY_INTRADAY: "15 min",
    GRANULARITY_DAILY: "Päivittäin",
    GRANULARITY_WEEKLY: "Viikoittain",
    POINTS: "{count} pistettä",
    POINT_SINGULAR: "{count} piste",
  },
  SEASON_STATS: {
    TITLE: "FPL-kausitilastot",
    DESCRIPTION:
      "Vertaa kaikkia pelaajia valitulta kaudelta. Suodata roolin tai joukkueen mukaan ja järjestä tilastosarakkeittain.",
    SEASON: "Kausi",
    NO_SEASON_DATA: "Ei kausidataa",
    PLAYERS: "Pelaajat",
    FILTER_SEASON: "Kausi",
    FILTER_TEAM: "Joukkue",
    FILTER_ROLE: "Rooli",
    FILTER_ROSTER: "Rosteri",
    ALL_TEAMS: "Kaikki joukkueet",
    ALL_ROLES: "Kaikki roolit",
    ALL_PLAYERS: "Kaikki pelaajat",
    MAIN_ROSTER_ONLY: "Vain päärosteri",
    SUBSTITUTES_ONLY: "Vain substitute",
    BENCHED_ONLY: "Vain benched",
    LOADING: "Ladataan tilastoja…",
    ERROR_SEASONS: "Kausitilastoja ei voitu ladata.",
    ERROR_PLAYERS: "Pelaajatilastoja ei voitu ladata.",
    NO_RESULTS: "Ei pelaajatilastoja valituilla suodattimilla.",
    CURRENT_SEASON_LIVE: "live",
    CURRENT_SEASON_NOTE: "Tilastot pelatuista peleistä tällä kaudella.",
    COLUMNS: {
      PLAYER: "Pelaaja",
      TEAM: "Joukkue",
      ROLE: "Rooli",
      GAMES: "Pelit",
      CHAMPS: "Champs",
      DOUBLE: "Double",
      TRIPLE: "Triple",
      QUADRA: "Quadra",
      PENTA: "Penta",
    },
    ROLES: {
      Top: "Top",
      Jungle: "Jungle",
      Mid: "Mid",
      ADC: "ADC",
      Support: "Support",
      Fill: "Fill",
    },
  },
  SEASON_SPLITS: {
    WINTER: "Talvi",
    SPRING: "Kevät",
    SUMMER: "Kesä",
    FALL: "Syksy",
  },
  CHAMPION_STATS: {
    TITLE: "FPL-hahmotilastot",
    DESCRIPTION:
      "Kaikki valitulla kaudella draftatut hahmot. Hae hahmoa, suodata roolin mukaan ja järjestä tilastosarakkeittain.",
    SEASON: "Kausi",
    NO_SEASON_DATA: "Ei kausidataa",
    CHAMPIONS: "Hahmot",
    FILTER_SEASON: "Kausi",
    FILTER_ROLE: "Rooli",
    FILTER_SEARCH: "Hahmo",
    ALL_ROLES: "Kaikki roolit",
    ROLE_UNAVAILABLE: "Tältä kaudelta ei ole roolitietoa.",
    SEARCH_PLACEHOLDER: "Hae hahmoa…",
    LOADING: "Ladataan hahmoja…",
    ERROR_SEASONS: "Kausilistaa ei voitu ladata.",
    ERROR_CHAMPIONS: "Hahmotilastoja ei voitu ladata.",
    NO_RESULTS: "Ei hahmoja valituilla suodattimilla.",
    NO_SEASON_STATS:
      "Tälle kaudelle ei ole vielä hahmodataa. Tilastot ilmestyvät, kun pelejä on pelattu.",
    RESULT_COUNT: "{count} hahmoa löytyi.",
    TABLE_CAPTION: "Valitun kauden hahmotilastot",
    CURRENT_SEASON_LIVE: "live",
    CURRENT_SEASON_NOTE: "Tilastot pelatuista peleistä tällä kaudella.",
    COLUMNS: {
      CHAMPION: "Hahmo",
      PICKS: "Picked",
      BANS: "Banned",
      WINS: "W",
      LOSSES: "L",
      WINRATE: "WR%",
      PICK_PCT: "Pick%",
      BAN_PCT: "Ban%",
      PRESENCE: "Presence",
      GAMES: "Pelit",
    },
  },
  STAT_TIER_LEGEND: {
    TITLE: "Tilastojen värit",
    INTRO:
      "Arvot on värikoodattu suoritustason mukaan (OP.GG-tyyli). Tasot vasemmalta oikealle: oranssi → sininen → vihreä → harmaa → punainen.",
    LABELS: {
      excellent: "Erinomainen",
      good: "Hyvä",
      average: "Keskitaso",
      low: "Heikko",
      poor: "Huono",
    },
    STATS: {
      KDA: "KDA",
      K: "K",
      DEATHS: "D",
      ASSISTS: "A",
      CSM: "CS/m",
      KP: "KP%",
      DPM: "DPM",
    },
    THRESHOLDS: {
      KDA: "≥5 · ≥4 · ≥3 · ≥2 · <2",
      K: "≥5 · ≥4 · ≥3 · ≥2 · <2 keskiarvo",
      D: "≤2 · ≤2.75 · ≤3.5 · ≤4.5 · >4.5 keskiarvo (pienempi on parempi)",
      A: "≥8 · ≥6 · ≥4.5 · ≥3 · <3 keskiarvo",
      CSM: "≥8.5 · ≥7.5 · ≥6.5 · ≥5.5 · <5.5",
      KP: "≥75 · ≥65 · ≥55 · ≥45 · <45",
      DPM: "≥700 · ≥600 · ≥500 · ≥400 · <400",
    },
  },
  ADS: {
    PREVIEW_BADGE: "Mainos esikatselu",
    PREVIEW_BANNER_HINT: "Responsiivinen banneri · ~728×90 työpöytä, ~320×50 mobiili",
    PREVIEW_FEED_HINT: "Sisältömainos · sisältölohkojen välissä",
    PREVIEW_SIDEBAR_HINT: "Sivupalkkimainos · ~160×600, kiinnittyy leveällä näytöllä",
    PREVIEW_MOBILE_HINT: "Mobiilibanneri · pysyy alareunassa selaamisen aikana",
    LOAD_ERROR: "Mainosta ei voitu ladata — tarkista slot-tunnus tai AdSense-hyväksyntä",
  },
  TCG: {
    INTRO_TITLE: "FPL TCG -kortit",
    INTRO_BODY: "Selaa tapahtuman FPL-keräilykortteja. Napauta korttia nähdäksesi sen tarkemmin.",
    ALL: "Kaikki",
    RARITY_STANDARD: "Standard",
    RARITY_LEGENDARY: "Legendary",
    RARITY_MYTHIC: "Mythic",
    RARITY_ULTIMATE: "Ultimate",
    EMPTY: "Tässä kategoriassa ei ole vielä kortteja.",
    CLOSE: "Sulje kuva",
    PREV: "Edellinen kortti",
    NEXT: "Seuraava kortti",
  },
  SEO: {
    HOME: {
      TITLE: "Finnhouse",
      DESCRIPTION:
        "Suomalaisen ammattilaistason League of Legends -liigan virallinen sivusto. Joukkue- ja pelaajatilastot, otteluohjelma, tulokset ja uusimmat kilpailupäivitykset.",
    },
    ABOUT: {
      TITLE: "Meistä",
      DESCRIPTION:
        "Tutustu Finnhouseen — Suomen suurimpaan LoL-turnaustoimijaan. FPL-, FCL- ja FHL-sarjat, lähetykset ja pelaajalähtöinen yhteisö vuodesta 2021.",
    },
    SCHEDULE: {
      TITLE: "Aikataulu",
      DESCRIPTION:
        "Tulevat Finnhouse-ottelut ja lähetysaikataulu. Suodata joukkueittain ja seuraa suomalaista LoL-liigaa Twitchissä.",
    },
    RESULTS: {
      TITLE: "Tulokset",
      DESCRIPTION:
        "Finnhouse-liigojen ottelutulokset. Selaa pelattuja sarjoja, tuloksia ja linkkejä yksityiskohtaisiin ottelutilastoihin.",
    },
    GALLERY: {
      TITLE: "Galleria",
      DESCRIPTION:
        "Kuvia ja hetkiä Finnhouse-tapahtumista, LAN-finaaleista ja suomalaisesta League of Legends -yhteisöstä.",
    },
    LEADERBOARD: {
      TITLE: "Ranked-tilastot",
      DESCRIPTION:
        "EUW-ranked-seuranta suomalaisen pro-liigan pelaajille. LP-historia, päivän liikkujat ja joukkueisiin linkitetyt tilit.",
    },
    STATS: {
      TITLE: "Kausitilastot",
      DESCRIPTION:
        "Pelaaja- ja joukkuetilastot Finnhouse-liigoissa. KDA, damage, vision ja suoritustasot kausittain.",
    },
    CHAMPIONS: {
      TITLE: "Hahmotilastot",
      DESCRIPTION:
        "Hahmojen pickit, banit, voittoprosentti ja presence kausittain Finnhouse-liigoissa, sekä KDA, CS/min ja damage hahmoittain.",
    },
    TEAMS: {
      TITLE: "Joukkueet",
      DESCRIPTION:
        "Suomalaisen pro-liigan joukkueet Finnhouse-sivustolla. Kokoonpanot, kuvaukset ja linkit pelaajiin.",
    },
    TEAM: {
      TITLE: "Joukkue",
      DESCRIPTION:
        "{team} — kokoonpano, otteluhistoria ja FPL-kausisijoitukset Finnhouse-sivustolla.",
    },
    TERMS: {
      TITLE: "Käyttöehdot",
      DESCRIPTION: "Finnhouse-sivuston ja palveluiden käyttöehdot.",
    },
    PRIVACY: {
      TITLE: "Tietosuojaseloste",
      DESCRIPTION:
        "Finnhouse-sivuston tietosuojaseloste — evästeet, analytiikka ja tiedonkäsittely.",
    },
    NOT_FOUND: {
      TITLE: "Sivua ei löytynyt",
      DESCRIPTION: "Pyytämääsi sivua ei löytynyt Finnhouse-sivustolta.",
      HOME_LINK: "Takaisin etusivulle",
    },
    OG_IMAGE_ALT: "Finnhouse-logo",
    MATCH: {
      TITLE: "Ottelu",
      DESCRIPTION: "Ottelun tiedot, tulostaulu ja tilastot Finnhouse-sarjasta.",
    },
    PLAYER: {
      TITLE: "Pelaaja",
      DESCRIPTION: "Pelaajaprofiili, kausitilastot ja otteluhistoria Finnhouse-sivustolla.",
    },
  },
};

export default fin;
